<template>
  <div class="modern-home">
    <div class="container">
      <!-- 桌面端侧边栏 -->
      <aside class="sidebar" v-if="!isMobile" ref="sidebar">
        <nav class="sidebar-nav">
          <div 
            class="nav-item" 
            :class="{ active: tabName === '全部' }"
            @click="clickTab('全部')"
            ref="navItemAll">
            <div class="nav-icon">
              <i class="el-icon-menu"></i>
            </div>
            <span>全部</span>
          </div>
          <div 
            class="nav-item" 
            v-for="(item, index) in tabList" 
            :key="index"
            :class="{ active: item.name === tabName }"
            @click="clickTab(item.name)"
            :ref="`navItem_${item.name}`">
            <div class="nav-icon">
              <img :src="item.icon" :alt="item.name">
            </div>
            <span>{{ item.name }}</span>
          </div>
        </nav>
      </aside>

      <!-- 主内容区 -->
      <main class="main-content">
        <!-- 搜索区域 -->
        <section class="search-section">
          <div class="search-container">
            <!-- 搜索标题 -->
            <h2 class="search-title">
              <span class="title-highlight">找兼职</span>
              <span class="title-dot">·</span>
              <span class="title-highlight">找服务</span>
              <span class="title-dot">·</span>
              <span class="title-highlight">找工具</span>
            </h2>

            <!-- 信任标识 -->
            <div class="trust-badges">
              <span class="trust-badge">
                <i class="el-icon-check"></i> 已收录 <strong>{{ webTotal || 0 }}</strong> 家平台
              </span>
              <span class="trust-badge">
                <i class="el-icon-view"></i> 第 <strong>{{ visits || 0 }}</strong> 位访客
              </span>
              <span class="trust-badge">
                <i class="el-icon-star-on"></i> 服务商认证
              </span>
            </div>
            
            <div class="search-box">
              <div class="search-input-wrapper">
                <el-input 
                  v-model="input"
                  placeholder="您要找的服务..."
                  class="modern-search"
                  @keyup.enter="searchName">
                </el-input>
                <button class="search-button" @click="searchName">
                  <i class="el-icon-search"></i>
                  <span v-if="!isMobile">搜索</span>
                </button>
              </div>
            </div>
            
            <p class="search-tips">
              <i class="el-icon-info" style="margin-right:6px;color:#a0aec0;font-size:14px;"></i>
              热门搜索：兼职、家政、软件开发、数据标注、知识产权
            </p>

            <!-- 热门搜索标签 -->
            <div class="hot-tags">
              <span class="hot-tag" @click="searchQuick('兼职')">#兼职</span>
              <span class="hot-tag" @click="searchQuick('家政')">#家政</span>
              <span class="hot-tag" @click="searchQuick('软件开发')">#软件开发</span>
              <span class="hot-tag" @click="searchQuick('数据标注')">#数据标注</span>
              <span class="hot-tag" @click="searchQuick('知识产权')">#知识产权</span>
              <span class="hot-tag" @click="searchQuick('企服财税')">#企服财税</span>
            </div>
          </div>
        </section>

        <!-- 移动端分类导航 -->
        <section class="mobile-categories" v-if="isMobile">
          <div class="categories-scroll">
            <div 
              class="category-tab"
              :class="{ active: tabName === '全部' }"
              @click="clickTab('全部')">
              全部
            </div>
            <div 
              class="category-tab"
              v-for="(item, index) in tabList" 
              :key="index"
              :class="{ active: item.name === tabName }"
              @click="clickTab(item.name)">
              {{ item.name }}
            </div>
          </div>
        </section>

        <!-- 内容区域 -->
        <section class="content-section">
          <div class="content-container">
            <template v-if="SlList && SlList.length !== 0">
              <div 
                class="category-group" 
                v-for="(category, index) in SlList" 
                :key="index">
                <div class="category-header">
                  <div class="category-title">
                    <img :src="category.icon" v-if="!isMobile">
                    <h3>{{ category.name }}</h3>
                  </div>
                  <!-- PC端公告显示 -->
                  <div class="notice-section" v-if="index === 0">
                    <HelloWorld />
                  </div>
                </div>
                
                <div class="platforms-grid">
                  <div 
                    class="platform-card"
                    v-for="(platform, idx) in category.list" 
                    :key="idx"
                    @click="clickAddress(platform.url, platform.name)">
                    <div class="card-content">
                      <div class="platform-header">
                        <div class="platform-logo">
                          <img :src="platform.logo" :alt="platform.name" :title="platform.desc">
                        </div>
                        <div class="platform-info">
                          <h4 class="platform-name">{{ platform.name }}</h4>
                          <p class="platform-desc">{{ platform.desc }}</p>
                        </div>
                      </div>
                      <div class="card-hover">
                        <i class="el-icon-link"></i>
                        <span>访问平台</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            
            <div class="empty-state" v-else>
              <el-empty description="暂无相关内容">
              </el-empty>
            </div>
          </div>
        </section>
      </main>
    </div>

    <!-- 返回顶部 -->
    <transition name="fade">
      <button 
        class="back-to-top" 
        @click="clickTop" 
        v-show="fShow2"
        aria-label="返回顶部">
        <i class="el-icon-arrow-up"></i>
      </button>
    </transition>
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld.vue"
import { getAll, getLb, recordHistory, webNum } from "../api/all.js"

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  },
  data() {
    return {
      tabList: [],
      tabName: '全部',
      fwNum: 0,
      fShow2: false,
      SlList: [],
      isMobile: null,
      input: '',
      isLoading: false,
      webTotal: 0,
      visits: 0
    }
  },
  async mounted() {
    this.checkMobile()
    
    // ===== 按指定顺序执行请求 =====
    // 1. /get_all_type - 获取分类
    await this.getTab()
    
    // 2. /get_services_pt - 获取服务列表
    await this.getSl()
    
    // 3. /get_tongji - 获取统计数据（这个方法会同时更新 App.vue）
    await this.getWebTotal()
    
    // 4. /list_notices - 在 HelloWorld 组件中自动调用
    // 5. /get_ad - 在 App.vue 中监听事件后调用
    
    // 数据加载完成后，通知 App.vue 可以加载广告了
    this.$nextTick(() => {
      this.$root.$emit('homeDataLoaded')
    })
    
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.checkMobile)
    
    setTimeout(() => {
      this.$forceUpdate()
    }, 100)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.checkMobile)
    this.$root.$off('homeDataLoaded')
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    // ===== 获取统计数据 =====
    async getWebTotal() {
      try {
        const res = await webNum()
        if (res && res.status === 1 && res.data) {
          const total = res.data[0] || 0
          const visit = res.data[1] || 0
          
          this.webTotal = total
          this.visits = visit
          
          // ===== 双重保障：同时使用两种方式传递数据到 App.vue =====
          
          // 方式1：通过 $root 事件总线发送
          this.$root.$emit('updateStats', {
            webTotal: total,
            visits: visit
          })
          
          // 方式2：直接更新父组件（App.vue）的数据
          if (this.$parent) {
            try {
              this.$parent.webTotal = total
              this.$parent.visits = visit
            } catch (e) {
              // 静默处理
            }
          }
          
          // 方式3：通过 $root 直接挂载（全局可用）
          if (this.$root) {
            try {
              this.$root._statsData = {
                webTotal: total,
                visits: visit
              }
            } catch (e) {
              // 静默处理
            }
          }
        }
      } catch (err) {
        console.error('获取统计数据失败:', err)
        this.webTotal = 0
        this.visits = 0
      }
    },
    async recordClick(name) {
      try {
        await recordHistory({ name })
      } catch (error) {
        console.error('记录点击失败:', error)
      }
    },
    // ===== 热门搜索快速跳转 =====
    searchQuick(keyword) {
      this.input = keyword
      this.searchName()
    },
    // ===== 点击分类切换 =====
    async clickTab(item) {
      if (this.isLoading) return
      this.isLoading = true
      
      this.tabName = item
      
      try {
        const params = item === '全部' ? {} : { type: item }
        const res = await getLb(params)
        this.SlList = res.data
        
        this.$nextTick(() => {
          this.scrollToActiveNavItem(item)
          this.isLoading = false
        })
      } catch (error) {
        console.error('获取分类数据失败:', error)
        this.$message.error('加载失败，请重试')
        this.isLoading = false
      }
    },
    // ===== 滚动左侧分类列表到当前选中项 =====
    scrollToActiveNavItem(itemName) {
      if (this.isMobile) return
      
      const sidebar = this.$refs.sidebar
      if (!sidebar) return
      
      let targetEl = null
      if (itemName === '全部') {
        targetEl = this.$refs.navItemAll
      } else {
        targetEl = this.$refs[`navItem_${itemName}`]
      }
      
      if (Array.isArray(targetEl)) {
        targetEl = targetEl[0]
      }
      
      if (!targetEl) return
      
      const sidebarRect = sidebar.getBoundingClientRect()
      const targetRect = targetEl.getBoundingClientRect()
      
      if (targetRect.top < sidebarRect.top || targetRect.bottom > sidebarRect.bottom) {
        const scrollOffset = targetEl.offsetTop - sidebar.clientHeight / 2 + targetEl.clientHeight / 2
        sidebar.scrollTo({
          top: Math.max(0, scrollOffset),
          behavior: 'smooth'
        })
      }
    },
    clickAddress(url, name) {
      this.recordClick(name)
      window.open(url, '_blank')
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.fShow2 = scrollTop > 500
    },
    clickTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    async getTab() {
      try {
        const res = await getAll()
        this.tabList = res.data
      } catch (error) {
        console.error('获取标签失败:', error)
      }
    },
    async getSl() {
      try {
        const res = await getLb()
        this.SlList = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async searchName() {
      try {
        const params = this.input ? { searchName: this.input } : {}
        const res = await getLb(params)
        this.SlList = res.data
      } catch (error) {
        console.error('搜索失败:', error)
        this.$message.error('搜索失败，请重试')
      }
    }
  }
}
</script>

<style scoped lang="less">
.modern-home {
  min-height: 100vh;
  background: var(--bg-light);
  width: 100%;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  padding: 5px 20px 20px;
  align-items: flex-start;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 5px 15px 15px;
  }
  
  @media (max-width: 768px) {
    padding: 5px 10px 10px;
    gap: 8px;
    width: 100%;
    max-width: 100%;
  }
}

/* 侧边栏 */
.sidebar {
  width: 280px;
  flex-shrink: 0;
  position: sticky;
  top: 8px;
  align-self: flex-start;
  height: auto;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  scroll-behavior: smooth;
  
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 transparent;
  
  &::-webkit-scrollbar {
    width: 5px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
  
  @media (max-width: 1024px) {
    width: 100%;
    position: static;
    max-height: none;
    overflow-y: visible;
  }
}

.sidebar-nav {
  background: var(--bg-white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-sm);
  padding: 15px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  
  contain: layout style;
  
  @media (max-width: 1024px) {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding: 12px;
    contain: none;
  }
}

/* 导航项 */
.nav-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-dark);
  border: 2px solid transparent;
  min-height: 60px;
  box-sizing: border-box;
  position: relative;
  
  transform: translateZ(0);
  will-change: transform;
  
  &:hover {
    background: rgba(62, 169, 246, 0.12);
    color: var(--primary);
    border-color: rgba(62, 169, 246, 0.2);
    transform: translateX(4px);
  }
  
  &.active {
    background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
    color: white;
    box-shadow: 0 0 0 2px rgba(62, 169, 246, 0.3), var(--shadow-md);
    border-color: #1a365d;
    transform: translateX(0);
    
    .nav-icon {
      background: rgba(255,255,255,0.25);
      transform: scale(1.05);
    }
  }
  
  @media (max-width: 1024px) {
    flex-shrink: 0;
    margin-bottom: 0;
    min-width: 120px;
    justify-content: center;
    flex-direction: column;
    min-height: 65px;
    
    &:hover {
      transform: translateY(-2px);
    }
  }
}

.nav-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  background: var(--bg-light);
  transition: all 0.25s ease;
  flex-shrink: 0;
  
  img {
    width: 20px;
    height: 20px;
    display: block;
    transition: transform 0.2s ease;
  }
  
  i {
    font-size: 18px;
    transition: transform 0.2s ease;
  }
  
  .nav-item:hover & {
    background: rgba(62, 169, 246, 0.15);
    
    img, i {
      transform: scale(1.1);
    }
  }
  
  .nav-item.active & {
    img, i {
      transform: scale(1.1);
    }
  }
  
  @media (max-width: 1024px) {
    margin-right: 0;
    margin-bottom: 5px;
  }
}

/* 主内容区 */
.main-content {
  flex: 1;
  min-width: 0;
  margin-top: 8px;
  width: 100%;
}

/* ===== 搜索区域 ===== */
.search-section {
  background: var(--bg-white);
  border-radius: 16px;
  padding: 30px 40px 25px;
  margin-bottom: 25px;
  color: var(--text-dark);
  text-align: center;
  box-shadow: var(--shadow-lg);
  border: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 16px 15px 10px;
    margin-bottom: 8px;
    border-radius: 12px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 12px 12px 8px;
    margin-bottom: 6px;
  }
}

/* ===== 搜索标题 ===== */
.search-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 14px 0;
  letter-spacing: 2px;
  
  .title-highlight {
    background: linear-gradient(135deg, #1a365d 0%, #4a6fa5 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .title-dot {
    color: #cbd5e0;
    margin: 0 6px;
    -webkit-text-fill-color: #cbd5e0;
  }
  
  @media (max-width: 768px) {
    font-size: 20px;
    margin: 0 0 8px 0;
    letter-spacing: 1px;
    
    .title-dot {
      margin: 0 3px;
    }
  }
  
  @media (max-width: 480px) {
    font-size: 17px;
    margin: 0 0 6px 0;
    
    .title-dot {
      margin: 0 2px;
    }
  }
}

/* ===== 信任标识 ===== */
.trust-badges {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  
  .trust-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #4a5568;
    
    i {
      color: #48bb78;
      font-size: 14px;
    }
    
    strong {
      color: #1a365d;
      font-weight: 700;
    }
  }
  
  @media (max-width: 768px) {
    gap: 10px;
    margin-bottom: 10px;
    
    .trust-badge {
      font-size: 11px;
    }
  }
  
  @media (max-width: 480px) {
    gap: 6px;
    margin-bottom: 6px;
    
    .trust-badge {
      font-size: 10px;
    }
  }
}

.search-container {
  position: relative;
  z-index: 1;
  width: 100%;
}

.search-box {
  max-width: 700px;
  margin: 0 auto 10px;
  width: 100%;
  
  @media (max-width: 768px) {
    margin: 0 auto 6px;
  }
  
  @media (max-width: 480px) {
    margin: 0 auto 4px;
  }
}

.search-input-wrapper {
  display: flex;
  width: 100%;
  border-radius: 60px;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
  background: white;
  
  &:focus-within {
    border-color: var(--primary);
    box-shadow: 0 0 0 4px rgba(62, 169, 246, 0.2);
    transform: translateY(-2px);
  }
}

.modern-search {
  flex: 1;
  
  /deep/ .el-input__inner {
    height: 56px;
    border: none;
    border-radius: 0;
    padding: 0 24px;
    font-size: 16px;
    box-shadow: none;
    background: transparent;
    font-weight: 500;
    
    &:focus {
      box-shadow: none;
      background: transparent;
    }
    
    @media (max-width: 768px) {
      height: 48px;
      padding: 0 16px;
      font-size: 15px;
    }
    
    @media (max-width: 480px) {
      height: 42px;
      padding: 0 12px;
      font-size: 14px;
    }
  }
}

.search-button {
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  color: white;
  border: none;
  padding: 0 32px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 16px;
  letter-spacing: 0.5px;
  
  &:hover {
    background: linear-gradient(135deg, #2d3748 0%, #1a365d 100%);
    transform: scale(1.02);
  }
  
  i {
    font-size: 17px;
  }
  
  @media (max-width: 768px) {
    padding: 0 20px;
    font-size: 14px;
    
    i {
      font-size: 15px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0 14px;
    font-size: 13px;
    
    span {
      display: none;
    }
  }
}

.search-tips {
  font-size: 14px;
  color: var(--text-light);
  margin-top: 10px;
  font-weight: 400;
  
  @media (max-width: 768px) {
    font-size: 12px;
    margin-top: 6px;
  }
  
  @media (max-width: 480px) {
    font-size: 11px;
    margin-top: 4px;
  }
}

/* ===== 热门标签 ===== */
.hot-tags {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 12px;
  
  .hot-tag {
    padding: 4px 14px;
    background: #f0f4ff;
    color: #4a6fa5;
    border-radius: 20px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid transparent;
    
    &:hover {
      background: #1a365d;
      color: white;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(26, 54, 93, 0.3);
    }
  }
  
  @media (max-width: 768px) {
    gap: 4px;
    margin-top: 6px;
    
    .hot-tag {
      font-size: 11px;
      padding: 2px 10px;
    }
  }
  
  @media (max-width: 480px) {
    gap: 3px;
    margin-top: 4px;
    
    .hot-tag {
      font-size: 10px;
      padding: 2px 8px;
    }
  }
}

/* 移动端分类 */
.mobile-categories {
  margin-bottom: 12px;
  background: var(--bg-white);
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: var(--shadow-sm);
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 480px) {
    margin-bottom: 8px;
    padding: 8px 10px;
  }
}

.categories-scroll {
  display: flex;
  overflow-x: auto;
  gap: 6px;
  padding-bottom: 2px;
  width: 100%;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 2px;
  }
  
  @media (max-width: 480px) {
    gap: 4px;
  }
}

.category-tab {
  padding: 8px 14px;
  background: var(--bg-light);
  border-radius: 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-dark);
  flex-shrink: 0;
  border: 2px solid transparent;
  
  &:hover {
    background: rgba(62, 169, 246, 0.1);
    color: var(--primary);
    border-color: rgba(62, 169, 246, 0.3);
  }
  
  &.active {
    background: #1a365d;
    color: white;
    border-color: #1a365d;
    box-shadow: var(--shadow-md);
  }
  
  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 16px;
  }
}

/* 内容区域 */
.content-section {
  background: var(--bg-white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-top: 0;
  width: 100%;
  
  @media (max-width: 768px) {
    border-radius: 10px;
  }
}

.content-container {
  padding: 0;
  width: 100%;
}

.category-group {
  padding: 30px 35px;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
  
  &:last-child {
    border-bottom: none;
  }
  
  @media (max-width: 768px) {
    padding: 16px 14px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 10px;
  }
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  width: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 14px;
  }
}

.category-title {
  display: flex;
  align-items: center;
  gap: 14px;
  
  img {
    width: 36px;
    height: 36px;
  }
  
  h3 {
    font-size: 1.6rem;
    color: var(--text-dark);
    margin: 0;
    font-weight: 700;
  }
  
  @media (max-width: 768px) {
    gap: 10px;
    
    img {
      width: 24px;
      height: 24px;
    }
    
    h3 {
      font-size: 1.1rem;
    }
  }
}

/* PC端公告显示 */
.notice-section {
  width: 400px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    width: 100%;
  }
}

.platforms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
  width: 100%;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
  }
}

.platform-card {
  background: var(--bg-white);
  border: 1px solid #f0f0f0;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
  
  &:hover {
    border-color: var(--primary);
    transform: translateY(-3px);
    box-shadow: var(--shadow-lg);
    
    .card-hover {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

.card-content {
  padding: 20px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 14px;
  }
}

.platform-header {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  width: 100%;
}

.platform-logo {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
  background: var(--bg-light);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
}

.platform-info {
  flex: 1;
  min-width: 0;
  width: 100%;
}

.platform-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-dark);
  margin: 0 0 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
}

.platform-desc {
  font-size: 0.9rem;
  color: var(--text-light);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
}

.card-hover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 54, 93, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  opacity: 0;
  transform: translateY(8px);
  transition: all 0.3s ease;
  width: 100%;
  
  i {
    font-size: 28px;
    margin-bottom: 10px;
  }
  
  span {
    font-weight: 700;
    font-size: 16px;
  }
}

/* 空状态 */
.empty-state {
  padding: 60px 20px;
  text-align: center;
  width: 100%;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow-xl);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 20px;
  
  &:hover {
    background: linear-gradient(135deg, #2d3748 0%, #1a365d 100%);
    transform: translateY(-3px) scale(1.05);
    box-shadow: var(--shadow-2xl);
  }
  
  @media (max-width: 768px) {
    right: 20px;
    bottom: 20px;
    width: 50px;
    height: 50px;
    font-size: 18px;
  }
}

/* 动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.sidebar {
  z-index: 99;
}

.sidebar-nav {
  min-height: 400px;
}

.sidebar.loading {
  opacity: 0.7;
  pointer-events: none;
}

@media (min-width: 1025px) {
  .sidebar {
    transition: transform 0.3s ease;
  }
  
  .modern-home.scrolled .sidebar {
    top: 100px;
  }
}

@media screen and (max-width: 768px) {
  .modern-home {
    width: 100%;
    overflow-x: hidden;
  }
  
  .container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }
  
  .main-content {
    width: 100%;
    max-width: 100%;
  }
  
  .search-section,
  .mobile-categories,
  .content-section {
    width: 100%;
    max-width: 100%;
  }
  
  .platforms-grid,
  .category-group,
  .content-container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }
}

@media print {
  .sidebar {
    position: static;
    page-break-inside: avoid;
  }
}
</style>